export default __webpack_public_path__ + "static/media/paneang.5ac6cc39.avif";